<div id="print-playground">
  <div class="page">
    <header>
      <h1 class="print">{{'report.playground.name' | translate }}</h1>
      <h2>{{ 'report.playground.name' | translate }}</h2>
      <h2>{{ report().made | timestamp:'d.M.yyyy' }}</h2>
      @if (site().image) {
        <div class="print">
          <img [src]="site().image" />
        </div>
      }
    </header>
  </div>
  <div class="page">
    <h3>{{ site().name | translate }}</h3>
    <table>
      <tr class="header">
        <td colspan="3">{{ 'home.renovation.participants' | translate }}</td>
      </tr>
      @for (user of report().participants; track $index) {
        <tr>
          <td>
            {{ user.name }}
          </td>
          <td>
            @if (user.company) {
              {{ user.company }}<br />
            }
            {{ user.role }}
          </td>
          <td>
            {{ user.email }}
          </td>
        </tr>
      }
    </table>
  </div>
  @for (item of fields; track $index) {
    <div class="page">
      <h3>{{ 'report.playground.items.' + item.title + '.title' | translate }}</h3>
      @for (subitem of item.items; track $index) {
        <h4>{{ 'report.playground.items.' + item.title + '.subitems.' + subitem + '.title' | translate }}</h4>
        <table>
          <tr class="header">
            <td>{{ 'report.playground.checked' | translate | translate }}</td>
            <td></td>
          </tr>
          <tr>
            <td>
              <ng-container [ngTemplateOutlet]="booleanTemplate"
                [ngTemplateOutletContext]="{ value: report()[item.title][subitem].checked }">
              </ng-container>
            </td>
            <td></td>
          </tr>
        </table>
        <table>
          <tr class="header">
            <td>{{ 'report.playground.item' | translate | translate }}</td>
            <td>{{ 'report.playground.condition' | translate | translate }}</td>
          </tr>
          <tr>
            <td>
              {{ report()[item.title][subitem].item }}
            </td>
            <td>
              {{ report()[item.title][subitem].condition }}
            </td>
          </tr>
        </table>
        <table>
          <tr class="header">
            <td>{{ 'report.playground.riskLevel' | translate | translate }}</td>
            <td>{{ 'report.playground.risk' | translate | translate }}</td>
          </tr>
          <tr>
            <td>
              {{ report()[item.title][subitem].riskLevel }}
            </td>
            <td>
              {{ report()[item.title][subitem].risk }}
            </td>
          </tr>
        </table>
        <div class="flex">
          @for (image of report()[item.title][subitem].images; track $index) {
            <img [src]="image"
              class="review-image" />
          }
        </div>
      }
    </div>
  }
</div>
<ng-template #booleanTemplate
  let-value="value">
  @if (value) {
    <ion-icon color="success"
      name="checkmark-outline"></ion-icon>
  } @else {
    <ion-icon color="danger"
      name="close-outline"></ion-icon>
  }
</ng-template>